export default __webpack_public_path__ + "static/media/sz-settings.d4e5dcb5.svg";